import apiClient from "./apiClient";
import { formatApiError } from "../lib/laravelError";

function pickList(obj, snakeKey) {
  if (!obj || typeof obj !== "object") return [];
  const camelKey = snakeKey.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
  const arr = obj[snakeKey] ?? obj[camelKey];
  return Array.isArray(arr) ? arr : [];
}

function pickKinkCategories(data) {
  if (!data || typeof data !== "object") return [];
  const raw = data.kink_categories ?? data.kinkCategories;
  return Array.isArray(raw) ? raw : [];
}

export const catalogService = {
  /**
   * body_types, hair_colors, eye_colors, skin_colors, ethnicities — { id, name }[]
   */
  async getPhysicalCharacteristics() {
    try {
      const { data } = await apiClient.get("/catalog/physical-characteristics");
      return data;
    } catch (err) {
      throw new Error(formatApiError(err, "No se pudo cargar características físicas"));
    }
  },

  /**
   * Mismas dimensiones que preferencias de pareja (sin skin_colors).
   */
  async getPartnerPreferences() {
    try {
      const { data } = await apiClient.get("/catalog/partner-preferences");
      return data;
    } catch (err) {
      throw new Error(formatApiError(err, "No se pudo cargar preferencias de pareja"));
    }
  },

  /**
   * kink_categories[] — { id, name, kinks: [{ id, name }] }
   */
  async getKinks() {
    try {
      const { data } = await apiClient.get("/catalog/kinks");
      return data;
    } catch (err) {
      throw new Error(formatApiError(err, "No se pudo cargar el catálogo de gustos"));
    }
  },
};

export function getDimensionList(catalogPayload, dimensionKey) {
  return pickList(catalogPayload, dimensionKey);
}

export function getKinkCategoryList(catalogPayload) {
  return pickKinkCategories(catalogPayload);
}
